export default __webpack_public_path__ + "static/media/CSI_CLUB.f258ed38.svg";